const isOtherRepoReason = (repoReason) =>
  (repoReason?.api?.format?.() || repoReason) === 'Other';

export default isOtherRepoReason;
